import React, { useState } from 'react'
import { Box } from '@usap/uicomponents'
import {
  BannerHeading,
  BannerImage,
  SeoBanner,
  BannerPicture,
  BannerText,
  BannerTextContainer,
} from './style/HeroshotBanner.css'

export default function HeroshotBanner({
  data: {
    backgroundImageDesktopDefault,
    backgroundImageMobileDefault,
    backgroundImageDesktop,
    backgroundImageMobile,
    alt = 'heroshot banner',
    partName,
    subText,
  },
}) {
  const [imageDesktop, setImageDesktop] = useState(backgroundImageDesktop)
  const [imageMobile, setImageMobile] = useState(backgroundImageMobile)

  const onError = () => {
    setImageMobile(backgroundImageMobileDefault)
    setImageDesktop(backgroundImageDesktopDefault)
  }

  return (
    <SeoBanner id="HeroshotBanner">
      <BannerPicture>
        <source srcSet={imageMobile} media="(max-width: 1023.98px)" />
        <source srcSet={imageDesktop} media="(min-width: 1024px)" />
        <BannerImage src={imageDesktop} alt={alt} onError={onError} />
      </BannerPicture>
      <BannerTextContainer id="HeroshotBannerTextContainer">
        <Box>
          <BannerHeading title={`${partName} Parts & Accessories`} />
          <BannerText>{subText}</BannerText>
        </Box>
      </BannerTextContainer>
    </SeoBanner>
  )
}
